import { FormValues } from '@ynap/form'

export const cleanAddressEmptyValues = (value: FormValues): FormValues => {
    const keys: string[] = Object.keys(value)
    let newAddressValues: Partial<FormValues> = {}
    
    keys.forEach((key: string) => {
        if ((typeof value[key] == 'string' || typeof value[key] == 'undefined') && (value[key]?.length === 0 || value[key] === null || value[key] === undefined)) {
            return
        }

        newAddressValues = {
            ...newAddressValues,
            [key]: value[key],
        }
    })
    return newAddressValues
}
